import { memo } from "react";
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import { ECommerceOnboarding, ECommerceOnboardingStep } from "consts/ecommerce";
import { StepLabel, type StepLabelProps } from "ui/organizms/ECommerce/Onboarding/common";

const DirectorsAndShareholdersLabel = (props: Partial<StepLabelProps>) => (
    <StepLabel
        to={`${ECommerceOnboardingStep[ECommerceOnboarding.HighRiskMerchant].DirectorsAndShareholders}`}
        Icon={PeopleOutlineIcon}
        {...props}
    >
        Directors / Shareholders
    </StepLabel>
);

export default memo(DirectorsAndShareholdersLabel);
